var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelivery2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2924.96 2881.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-10 {\n        fill: #fff;\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-24, .cls-25 {\n        opacity: .3;\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-15);\n        isolation: isolate;\n      }\n\n      .cls-26 {\n        fill: #f4f7fa;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1483.16,
    y1: 1418.75,
    x2: 1084.7,
    y2: 341.43,
    gradientTransform: "translate(0 2843.93) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#fdba46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#ffc244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#fdb946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f99c4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#f8924f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8924f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 2555.51,
    y1: 948.01,
    x2: 2924.96,
    y2: 948.01,
    gradientTransform: "translate(0 2843.93) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#fdba46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#ffc244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#fdb946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f99c4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#f8924f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8924f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1465.54,
    y1: 2260.2,
    x2: 2279.29,
    y2: 164.2,
    gradientTransform: "translate(0 2843.93) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1797.13,
    y1: 662.62,
    x2: 1259.59,
    y2: -153.27,
    gradientTransform: "translate(0 2843.93) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1494.49,
    y1: 2260.2,
    x2: 2308.23,
    y2: 164.2,
    gradientTransform: "translate(0 2843.93) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb6fbb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1205.27,
    y1: 2147.73,
    x2: 2019.2,
    y2: 51.24,
    gradientTransform: "translate(0 2843.93) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb6fbb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1826.07,
    y1: 662.62,
    x2: 1288.54,
    y2: -153.27,
    gradientTransform: "translate(0 2843.93) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb6fbb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 895.48,
    y1: 1164.29,
    x2: 863.16,
    y2: 1076.92,
    gradientTransform: "translate(-730.31 2323.98) rotate(10.63) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f36f56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 2232.31,
    y1: 1584.83,
    x2: 2203.13,
    y2: 1505.93,
    gradientTransform: "translate(-730.31 2323.98) rotate(10.63) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f36f56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1965.21,
    y1: 1688.86,
    x2: 1477.33,
    y2: 369.77,
    gradientTransform: "translate(-730.31 2323.98) rotate(10.63) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa80f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165d7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 2019.68,
    y1: 138.7,
    x2: 2092.59,
    y2: 138.7,
    gradientTransform: "translate(3095.52 3041.51) rotate(-169.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f36f56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1931.62,
    y1: 118.06,
    x2: 2061.12,
    y2: 118.06,
    gradientTransform: "translate(3095.52 3041.51) rotate(-169.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 2014.46,
    y1: 165.21,
    x2: 2000.13,
    y2: 132.09,
    gradientTransform: "translate(3095.52 3041.51) rotate(-169.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 2355.64,
    y1: 875.04,
    x2: 1959.35,
    y2: 187.36,
    gradientTransform: "translate(3095.52 3041.51) rotate(-169.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 2401.38,
    y1: 848.68,
    x2: 2005.09,
    y2: 161,
    gradientTransform: "translate(3095.52 3041.51) rotate(-169.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 3083.27,
    y1: 269.54,
    x2: 3143.21,
    y2: 269.54,
    gradientTransform: "translate(3095.52 3041.51) rotate(-169.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 2850.15,
    y1: 1023.88,
    x2: 2585.4,
    y2: 429.43,
    gradientTransform: "translate(3095.52 3041.51) rotate(-169.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1606.69,
    y1: 1821.44,
    x2: 1118.81,
    y2: 502.36,
    gradientTransform: "translate(-730.31 2323.98) rotate(10.63) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa80f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165d7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 2987.84,
    y1: 4620.64,
    x2: 2997.23,
    y2: 4870.64,
    gradientTransform: "translate(-3600.7 4023.33) rotate(24) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f36f56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -1446.96,
    y1: 4185.19,
    x2: -1505.65,
    y2: 4334.24,
    gradientTransform: "translate(124.27 5262.13) rotate(173.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b3976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 2262.93,
    y1: 4182.42,
    x2: 2260.3,
    y2: 3970.88,
    gradientTransform: "translate(-374.33 5342.24) rotate(-10.38) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f36f56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1258.46,
    y1: 1950.23,
    x2: 770.58,
    y2: 631.15,
    gradientTransform: "translate(-730.31 2323.98) rotate(10.63) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa80f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165d7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1588.47,
    y1: 2004.95,
    x2: 929.11,
    y2: 222.24,
    gradientTransform: "translate(-730.31 2323.98) rotate(10.63) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa80f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165d7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M2563.52,2478.04c-75.48,77.8-143.02,123.54-194.73,158.07-504.31,336.73-1080.8,239.68-1259.03,206.51-287.56-53.52-530.3-91.28-738.86-279.7-473.9-428.15-450.85-1321.31-88.73-1874.59C325.11,622.73,686.68,86.76,1264.41,11.24c14.13-1.85,24.67-2.9,33.91-3.88,89.37-9.46,643.21-59.4,1094.8,318.94,64.64,54.16,168.67,151.85,265.14,300.83,352.74,544.77,353.86,1388.51-94.74,1850.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M76.04,1758.62c131.51-7.04,264.28-2.82,394.37,20.12,32.49,5.77,64.81,12.48,96.8,20.57,16.09,3.55,31.91,8.4,47.78,12.86,7.92,2.3,15.88,4.43,23.75,6.88l23.48,7.83c62.57,20.78,123.68,46.01,181.97,76.58,29.28,14.98,57.75,31.53,85.52,49.07,27.76,17.56,54.85,36.15,81,55.89,26.17,19.73,51.35,40.64,75.79,62.25,24.42,21.63,48.02,44.08,70.63,67.34,45.23,46.51,87.3,95.46,127.1,145.25,39.82,49.72,77.9,100.12,117.33,147.01,19.78,23.33,39.9,45.84,61.39,65.28,21.42,19.47,44.05,36,67.71,46.55,23.68,10.47,48.29,14.69,73.96,12.49,25.69-2.34,50.29-10.78,73.35-24.47,11.54-6.82,22.7-14.86,33.47-23.85,10.73-9.07,20.97-19.13,30.93-29.73,19.92-21.22,38.38-44.98,56.21-69.63,35.21-49.79,68.09-103.21,102.27-156.87,34.45-53.53,70.21-107.6,111.83-158.95,41.4-51.37,88.81-100.22,144.31-141.5,27.76-20.56,57.47-39.1,88.74-55.14,31.36-15.82,64.23-29.17,98.01-39.64,33.77-10.55,68.41-18.02,103.48-23.14,17.55-2.45,35.21-4.47,52.99-5.69,17.76-1.19,35.71-1.7,53.61-1.72h1.59c44.44-.05,80.5,35.93,80.55,80.37.05,44.44-35.93,80.5-80.37,80.55-5.05,0-10.42-.55-15.22-1.43-53.69-10.27-110.3-10.83-164.95-1.36-13.62,2.52-27.24,5.31-40.61,9.04-3.35.92-6.73,1.77-10.05,2.8l-9.94,3.17c-6.69,1.97-13.14,4.61-19.75,6.88-26.19,9.75-51.42,22.45-75.91,37.02-12.17,7.44-24.18,15.26-35.8,23.84-11.74,8.39-23.09,17.5-34.35,26.82-11.17,9.46-22.11,19.3-32.73,29.64-5.39,5.06-10.54,10.46-15.84,15.67-5.14,5.42-10.41,10.69-15.47,16.24-20.5,21.89-39.81,45.28-58.72,69.35-18.97,24.01-37.07,49.07-55.07,74.49-36.23,50.75-70.71,103.86-110.06,155.63-19.59,25.96-40.31,51.69-63.99,75.95-23.64,24.14-50.09,47.29-81.42,65.55-15.62,9.1-32.41,16.88-50.06,22.66-17.64,5.81-36.07,9.54-54.6,11.17-18.53,1.67-37.66,1.1-56.39-2-18.74-3.07-37-8.66-54-16.08-34.04-15.03-62.68-36.48-87.92-59.13-25.24-22.81-47.65-46.94-68.87-71.38-42.35-48.92-80.61-98.78-120.83-146.3-39.97-47.65-80.98-93.59-125.13-135.86-87.71-84.93-187.63-155.41-297.43-205.02-109.56-50.03-227.34-80.24-346.83-91.73-59.77-5.8-119.99-6.92-180.04-3.98-60.06,3-119.92,10.13-179.28,20.77-43.59,7.81-85.26-21.19-93.07-64.78s21.19-85.26,64.78-93.07c3.15-.56,6.28-.94,9.4-1.12l.59-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2598.45,1703.24l301.44,143.79c31.05,14.81,33.81,51.92,5.19,69.93l-270.04,169.97c-23.74,14.94-55.36-6.65-43.31-29.57l45.97-87.48c22.89-43.56,19.42-93.86-9.3-134.85l-68.67-98.01c-15.04-21.47,13.09-46.01,38.73-33.78Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2388.17,875.97c0,339.16-479.5,967.2-699.39,1237.62-55.01,67.64-158.14,70.26-213.47,5.14-223.53-263.03-724.17-891.73-724.17-1241.49,0-452.05,375.3-813.12,831.12-806.56,448.14,6.45,805.92,366.94,805.92,805.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1748.99,2503c0,90.69-74.52,166.79-166.74,169.97-92.54,3.2-167.79-68.18-167.79-159.45s75.25-167.38,167.79-170.01c92.22-2.62,166.74,68.79,166.74,159.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2417.12,875.97c0,339.16-479.5,967.2-699.4,1237.62-55.01,67.64-158.14,70.26-213.47,5.14-223.53-263.03-724.17-891.73-724.17-1241.49,0-452.05,375.3-813.12,831.12-806.56,448.14,6.45,805.92,366.94,805.92,805.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2063.71,876.25c0,246.12-201.64,447.51-452.51,449.82-253.26,2.34-460.34-198.73-460.34-449.11s207.08-451.77,460.34-449.83c250.87,1.93,452.51,203,452.51,449.12Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1607.59,1785.33c51.88-337.34,276.29-447.16,237.91-763.34-44.34-365.21-373.69-464.24-381.69-791.53-1.29-52.7,6.01-103.41,19.77-151.86-396.28,55.2-703.49,389.92-703.49,798.65,0,349.77,500.64,978.46,724.17,1241.49,32.58,38.34,81.76,53.18,127.91,45.09-39.67-146.54-40.88-272.51-24.58-378.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1777.94,2503c0,90.69-74.52,166.79-166.74,169.97-92.54,3.2-167.79-68.18-167.79-159.45s75.25-167.38,167.79-170.01c92.22-2.62,166.74,68.79,166.74,159.48Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347.24,1334.54s-1.41,31.98,9.14,43.11,17.63,46.85-2.22,54.66-52.24-15.51-55.64-21.89c-3.4-6.38,11.07-3.89,18.13-4.75s-5.49-31.94-3.27-49.91c2.22-17.97,33.86-21.22,33.86-21.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1707.91,1247.52c1.74-3.12,16.1-24.56,15.62-46.48-.48-21.92,3.54-18.87,6.94-12.49s5.63-12.73,29.39-7.12c23.75,5.61-3.2,47.66-33.89,75.22l-18.05-9.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1150.9,997.66c46-6.1,105.95-5.62,153.91,28.89,99.65,71.69,56.73,224.93,134.97,273.3,39.49,24.41,112.72,23.89,259.58-73.62,15.29,11.04,30.58,22.08,45.87,33.12-3.81,10.88-71.61,194.87-249.99,233.62-156.59,34.02-330.07-58.72-402.23-229.08,19.29-88.74,38.59-177.49,57.88-266.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1068.6,2497.35c1.25,1.21,20.68,41.34,28.14,66.59l35.67-11.32s-17.04-9.93-19.6-46.97c-2.55-37.04-44.21-8.3-44.21-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1138.7,2593.66s-21.6,3.06-30.17,2.09l-.86-.1c-4.85-.55-9.09-3.52-11.23-7.9-3.74-7.64-9.05-19.13-8.66-21.99.6-4.38,14-11.08,25.18-12.98,11.18-1.9,14.59-6.6,36.88-18.45,22.28-11.84,58.46-24.08,71.14-7.05,12.67,17.03-8.1,49.61-82.27,66.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1209.32,2527.4c-18.09,3.54-26.72,21.53-59.54,35.27-18.62,7.8-40.94,13.98-56.77,17.87-2.89-6.3-5.52-12.75-5.24-14.79.6-4.38,14-11.08,25.18-12.98,11.18-1.9,14.59-6.61,36.88-18.45s58.46-24.07,71.14-7.05c3.23,4.34,4.27,9.69,2.83,15.53-1.49-8.74-5.27-17.2-14.48-15.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1054.57,1508.69c32.39,114.47,61.8,250.28,78.27,404.33,24.54,229.49,12.88,429.59-8.23,586.18-20.03,4.19-40.07,8.38-60.1,12.56-32.16-30.14-78.06-81.19-105.09-155.14-44.31-121.21,11.79-167.92-16.24-308.97-27.18-136.73-91.46-151-121.55-299.77-17.95-88.75-11.53-165.08-3.85-214.18,78.93-8.34,157.86-16.68,236.79-25.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M946.68,1520.09c-29.93,48.33-35.67,87.81-33.29,117.97,7.93,100.39,108.02,129.9,112.26,241.3,2.85,74.76-41.42,82.86-33.68,161.4,8.21,83.33,59.55,89.38,71.97,176.14,9.77,68.2-18.33,89.78-25.6,181.55-2.52,31.76-1.66,61.25,1.02,87.9-28.01-30.62-59.42-73.54-79.95-129.71-44.31-121.21,11.79-167.92-16.24-308.97-27.18-136.73-91.46-151-121.55-299.77-17.95-88.75-11.53-165.08-3.85-214.18,42.97-4.54,85.94-9.08,128.91-13.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M92.52,2122.66s-14.73,2.59-24.45,20.67c-9.72,18.08-14.72,99.88-9.71,121.15,5.01,21.27,31.5,21.39,41.78,7.84,10.28-13.55,19.51-121.32,19.51-121.32l-27.12-28.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1037.48,1554.62c-75.94,70.72-131.09,134.02-167.37,178.65-76.65,94.32-99.17,142.48-184.6,227.47-79.11,78.7-126.22,103.5-145.31,112.82-46.04,22.49-81.91,29.72-173.8,46.06-80.3,14.28-165.22,28.75-254.48,43.12-15.09-1.11-20.1-8.66-21.65-22.82,13.36-63.61,39.9-99,60.18-119.08,43.27-42.87,78.63-36.49,197.95-91.34,63.62-29.24,96.04-44.44,125.81-72.54,14.32-13.52,38.43-39.1,88.57-143.33,20.55-42.71,46.52-100.82,72.59-172.07,134.04,4.35,268.08,8.7,402.12,13.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1304.86,1027.86c-48.12-35.35-127.98-84.51-237.01-112.12-157.24-39.81-289-12.98-352.54,4.53-24.29,43.04-28.82,77.2-28.05,101.21.58,17.94,3.8,41.85,2.46,81.69-.35,10.55-1.46,22.38-3.88,36.83-14.79,88.42-48.79,95.85-85.08,207.55-29.88,91.95-16.21,115.78-51.09,149.85-25.02,24.45-53.85,33.47-77.69,74.55-7.89,13.6-27.54,47.45-16.09,61.76,18.34,22.93,86.65-41.56,189.88-32.73,55.06,4.71,59.79,25.13,117.81,24.96,63.33-.18,63.51-24.51,122.98-25.35,58.95-.83,72.34,22.89,161.24,28.84,37.4,2.5,56.1,3.75,69.41-4.25,43.05-25.88,24.81-96.88,37.44-200.74,9.28-76.29,26.27-96.9,50.29-163.88,15.66-43.68,15.47-54.03,27.15-89.36,11.78-35.62,32.73-85.7,72.77-143.35Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1071.05,833.19c-9.66,14.65-7.13,48.06-36.91,61.17-26.21,11.54-32.82,12.54-43.51,12.63-26.63.22-37.18-5.67-39.21-1.84-4.57,8.59,46.63,60.14,115.15,70.37,39.82,5.95,95.86-20.61,83.97-27.02-55.42-29.92-64.11-41.99-29.84-91.38-17.9-8.72-31.75-15.21-49.65-23.94Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1135.34,815.31c6.73-10.56,5.66-27.09-4.09-36.2-8.39-7.84-20.4-7.38-27.59-7.1-20.87.81-46.25,12.67-53.7,31.75-4.42,11.31,9.27,31.44,11.46,35.1,2.48,4.14,6.37,5.1,10.15,7.94,5.24,3.94,13.44,10.22,26.86,20.77.61-3.8,1.64-8.54,3.48-13.78.71-2.02,3.58-9.91,8.38-16.82,9.62-13.83,18.66-11.64,25.05-21.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1079.96,859.78s15.54,18.76,42.45,13.04c24.04-5.1,22.84-56.18,6.41-64.61-5.49-2.81-15.95-2.77-24.14.66-4.84,2.03-6.34,4.2-14.32,7.38-7.36,2.94-9.56,2.47-11.67,4.59-2.64,2.65-4.21,8.43,1.91,22.53-5.04-3.67-10.75-4.52-14.53-2.2-.6.37-2.17,1.67-2.96,3.41-2.86,6.3,3.51,12.84,16.85,15.2Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M903.44,895.06c-253.44-57.29-487.79,34.24-574.05,204.03-51.67,101.69-38.1,207.6-25.21,264.9,19.67-1.42,39.34-2.83,59.01-4.24,23.64-66.05,67.62-154.26,151.36-186.07,101.91-38.72,182.76,36.49,266.94-1.99,48.22-22.04,104.92-84.76,121.95-276.63Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1077.44,1571.85c-58.27-37.73-54.22-101.48-107.32-117.66-63.36-19.31-104.12,60.8-171.89,46.51-60.91-12.84-117.15-96.34-109.35-166.8,14.66-132.51,253.5-197.93,240.54-232.41-5.78-15.38-52.42-.07-132.02-6.03-138.34-10.35-157.3-68.54-240.37-58.24-96.72,11.99-172.97,103.53-204.97,182.82-22.64,56.1-23.87,107.86-21.16,142.03,10.76-.77,21.52-1.55,32.28-2.32,23.64-66.05,67.63-154.26,151.36-186.07,59.85-22.74,112.44-6.19,162.7,3.55-17.23,56.29-46.05,76.65-76.49,170.33-29.88,91.96-16.21,115.78-51.09,149.85-25.02,24.45-53.84,33.47-77.69,74.55-7.9,13.6-27.54,47.45-16.09,61.76,18.33,22.93,86.65-41.56,189.88-32.73,55.06,4.71,59.79,25.13,117.81,24.96,63.33-.18,63.51-24.51,122.98-25.35,58.95-.83,72.34,22.89,161.24,28.84,37.4,2.5,56.1,3.75,69.41-4.25,11.94-7.18,19.15-17.84,23.63-31.7-22.72-2.52-44.22-9.23-63.4-21.65Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery2);
export default __webpack_public_path__ + "static/media/delivery2.689360dc4c6f31da31b52d263995cacd.svg";
export { ForwardRef as ReactComponent };